import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

import { ButtonWrapper, LogoutButton, CancelLogoutButton } from "./styles";

import getOpco from "utils/getOpco";
import { ULFEvents } from "types/ULF";
import { logoutUserFromAPI } from "state/user-slice";
import { clearCartState } from "state/cart-slice";
import { clearOffersState } from "state/offers-slice";

import Admin from "components/IconImage/admin";

import { clearConfigState, sendULFEvent, setLoader, setModal } from "state/config-slice";

export default function useLogoutModal() {
  const [cookies, , removeCookie] = useCookies();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const logout = async () => {
    await dispatch(
      sendULFEvent({
        "event-name": ULFEvents.REDIRECT_TO_HOME_PAGE,
        page: window.location.pathname,
        source: cookies.SOURCE,
        isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
      }),
    );

    dispatch(setLoader({ showLoader: true, messageHeader: t("Processing your request"), messageText: "" }));
    const result = await dispatch(logoutUserFromAPI());
    removeCookie("openidRefreshToken", { path: "/" });
    removeCookie("openidAccessToken", { path: "/" });
    removeCookie("idToken", { path: "/" });
    removeCookie("SUBSCRIPTIONPLUS_TRACKING", { path: `/marketplace/${getOpco()}` });
    removeCookie("SOURCE");
    removeCookie("CART", { path: "/" });
    removeCookie("Optin", { path: "/" });
    dispatch(clearCartState());
    dispatch(clearOffersState());
    dispatch(clearConfigState());
    dispatch(setModal({ showModal: false }));
    sessionStorage.removeItem("wasEverCableURL");

    if (result.payload.redirectUrl) {
      window.location.href = result.payload.redirectUrl;
    } else {
      navigate("/");
    }
  };

  const openLogoutModal = (): void => {
    dispatch(
      setModal({
        showModal: true,
        cross: true,
        icon: <Admin />,
        title: t("Do you want to log out?"),
        type: "logout",
        customButtons: (
          <ButtonWrapper>
            <LogoutButton id="yes-log-me-out" title={t("Yes, Log me out")} onClick={logout} />
            <CancelLogoutButton
              id="no-thanks"
              title={t("No thanks")}
              onClick={() => {
                dispatch(setModal({ showModal: false }));
                dispatch(
                  sendULFEvent({
                    "event-name": ULFEvents.CANCEL_CLICKED,
                    page: window.location.pathname,
                    source: cookies.SOURCE,
                    isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
                  }),
                );
              }}
            />
          </ButtonWrapper>
        ),
      }),
    );
  };

  return { openLogoutModal };
}
